export const configUK = {
  mobileNumberMinLength: 10,
  moneySymbol: '£'
};
